// Web Component: GiftCard
// Gestisce la visualizzazione e la logica delle gift card, inclusa la gestione degli stati del form.
// Attributi richiesti: nessuno specifico
// Dipendenze: Utils, theme-form, theme-loader, formErrors
// Limiti: richiede struttura HTML compatibile e presenza di template figli
// Utilizzato nella pagina di gestione delle gift card
class GiftCard extends HTMLElement {
  form;

  connectedCallback() {
    this.form = this.querySelector('theme-form');
    this.form.addEventListener(Utils.E_FORM_SUCCESS, this.onFormSuccess.bind(this));
    this.form.addEventListener(Utils.E_FORM_ERROR, this.onFormError.bind(this));
    this.form.addEventListener(Utils.E_FORM_SUBMIT, this.onFormSubmit.bind(this));
    this.form.addEventListener(Utils.E_FORM_SENT, this.onFormSent.bind(this));
  }

  onFormSent = () => {
    const loader = document.querySelector('theme-loader[data-global]');
    if(loader){
      loader.hide();
    }
  }

  onFormSubmit = () => {
    const loader = document.querySelector('theme-loader[data-global]');
    if(loader){
      loader.show();
    }
  }

  onFormError = (event) => {
    Utils.errorHandler({
      message: formErrors.generic,
      popup: true
    });
  }

  onFormSuccess = (event) => {
    const data = event.detail;
    if(data.Success){
      const today = parseInt(GiftCard.formatDate(new Date()));
      const expire = parseInt(data.DueDate);
      const template = today > expire ? this.querySelector('template[name="expired"]') : this.querySelector('template[name="balance"]');
      this.innerHTML = template.innerHTML
                        .replaceAll('{coupon}', data.Coupon)
                        .replaceAll('{date}', GiftCard.formatDateString(data.DueDate))
                        .replaceAll('{balance}', Utils.money(data.Value*100));
    } else {
      Utils.errorHandler({
        message: this.dataset.errorMsg || formErrors.generic,
        popup: true
      });
    }
  }

  static formatDateString(date) {
    const y = date.substring(0, 4);
    const m = date.substring(4, 6);
    const d = date.substring(6, 8);
    return `${d}/${m}/${y}`;
  }

  static formatDate(date) {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    return `${y}${m < 10 ? '0' + m : m}${d < 10 ? '0' + d : d}`;
  }

}
if (!customElements.get('gift-card')) {
  customElements.define('gift-card', GiftCard);
}